import { render, staticRenderFns } from "./UploadVoice.vue?vue&type=template&id=120ad487&scoped=true&"
import script from "./UploadVoice.vue?vue&type=script&lang=js&"
export * from "./UploadVoice.vue?vue&type=script&lang=js&"
import style0 from "./UploadVoice.vue?vue&type=style&index=0&id=120ad487&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ad487",
  null
  
)

export default component.exports